/* Mobile "Show more" for the Judge.me review list.

   Judge.me's widget is a Vue app rendered by the app block, so nothing here touches its
   components, markup or classes — it only measures the rendered DOM, sets a max-height on
   the grid, and appends a button next to it.

   Clipping the grid (rather than hiding cards) is deliberate: the list is a masonry, so
   pulling cards out of flow can restack the survivors. Judge.me already ships
   `overflow:hidden` + `transition:max-height` on .jdgm-masonry-grid, so this rides on
   styling that is already there.
*/
(function () {
  var GRID = '.jdgm-masonry-grid';
  var CARD = '.jdgm-review-card';
  var VISIBLE = 4; // reviews shown before "Show more"
  var mobile = window.matchMedia('(max-width: 749px)');

  function firstCardsBottom(grid) {
    // Masonry can reorder visually, so take the lowest edge of the first VISIBLE cards
    // rather than assuming the VISIBLE-th one is the deepest.
    var cards = grid.querySelectorAll(CARD);
    if (cards.length <= VISIBLE) return 0; // nothing to hide

    var gridTop = grid.getBoundingClientRect().top;
    var bottom = 0;
    for (var i = 0; i < VISIBLE; i++) {
      var r = cards[i].getBoundingClientRect();
      bottom = Math.max(bottom, r.bottom - gridTop);
    }
    return Math.round(bottom);
  }

  function collapse(grid) {
    var h = firstCardsBottom(grid);
    if (!h) {
      expand(grid, true);
      return false;
    }
    grid.style.maxHeight = h + 'px';
    grid.classList.add('ib-rev-collapsed');
    return true;
  }

  function expand(grid, silent) {
    grid.style.maxHeight = silent ? '' : grid.scrollHeight + 'px';
    grid.classList.remove('ib-rev-collapsed');
    if (!silent) {
      // Drop the inline height once the transition is done so later re-renders
      // (sorting, pagination, lazy images) are not capped at today's height.
      window.setTimeout(function () {
        grid.style.maxHeight = '';
      }, 350);
    }
  }

  function button(grid) {
    var existing = grid.nextElementSibling;
    if (existing && existing.classList.contains('ib-rev-more-wrap')) return existing;

    var wrap = document.createElement('div');
    wrap.className = 'ib-rev-more-wrap';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ib-rev-more';
    btn.textContent = 'Show more';
    btn.addEventListener('click', function () {
      grid.dataset.ibExpanded = 'true';
      expand(grid);
      wrap.remove();
    });

    wrap.appendChild(btn);
    grid.parentNode.insertBefore(wrap, grid.nextSibling);
    return wrap;
  }

  function apply() {
    document.querySelectorAll(GRID).forEach(function (grid) {
      if (!mobile.matches || grid.dataset.ibExpanded === 'true') {
        expand(grid, true);
        var w = grid.nextElementSibling;
        if (w && w.classList.contains('ib-rev-more-wrap')) w.remove();
        return;
      }
      if (collapse(grid)) button(grid);
    });
  }

  var pending;
  function schedule() {
    window.clearTimeout(pending);
    pending = window.setTimeout(apply, 120);
  }

  // The widget renders late and re-renders on sort/filter/pagination, and lazy-loaded
  // review photos change card heights after the fact — so re-measure on all of it.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  schedule();
})();
